// removed by extract-text-webpack-plugin
module.exports = {"inline-signup":"inline-signup___2pA5O","inline-signup__icon":"inline-signup__icon___3PtrY","inline-signup__headline":"inline-signup__headline____hb6k h2___hzLuT","inline-signup__copy":"inline-signup__copy___2Vofr h3___5u0xZ","inline-signup__form-wrap":"inline-signup__form-wrap___256-r center___2iqBf","inline-signup__form":"inline-signup__form___34YrY center___2iqBf","inline-signup__input":"inline-signup__input___NmEik","inline-signup__submit":"inline-signup__submit___1awB8"};


//////////////////
// WEBPACK FOOTER
// ./src/core/InlineSignup/InlineSignup.css
// module id = 884
// module chunks = 0